(function () {
  'use strict';

  var configElement;
  var matrixPromise;
  var bracketCatalogPromise;
  var checkTimer;
  var storageKey = 'fgBracketCompatibilityWarningV2';
  var legacySessionKey = 'fgBracketCompatibilityWarning';

  function getDismissedSignature() {
    try {
      if (window.localStorage) return window.localStorage.getItem(storageKey) || '';
    } catch (_error) {}
    try {
      if (window.sessionStorage) return window.sessionStorage.getItem(storageKey) || '';
    } catch (_error) {}
    return '';
  }

  function setDismissedSignature(value) {
    try {
      if (window.localStorage) window.localStorage.setItem(storageKey, value);
      else if (window.sessionStorage) window.sessionStorage.setItem(storageKey, value);
    } catch (_error) {
      try {
        if (window.sessionStorage) window.sessionStorage.setItem(storageKey, value);
      } catch (_fallbackError) {}
    }
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(legacySessionKey);
    } catch (_error) {}
  }

  function clearDismissedSignature() {
    try {
      if (window.localStorage) window.localStorage.removeItem(storageKey);
    } catch (_error) {}
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem(storageKey);
        window.sessionStorage.removeItem(legacySessionKey);
      }
    } catch (_error) {}
  }

  function productHandle(item) {
    if (item && item.handle) return String(item.handle).toLowerCase();
    var match = item && item.url && String(item.url).match(/\/products\/([^/?#]+)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function parseMatrix(text) {
    var matrix = new Map();
    String(text || '').split(/\r?\n/).slice(1).forEach(function (line) {
      var comma = line.indexOf(',');
      if (comma < 1) return;
      var actuator = line.slice(0, comma).trim().toLowerCase();
      var brackets = line.slice(comma + 1).trim().toLowerCase().split('/').filter(Boolean);
      if (actuator && brackets.length) matrix.set(actuator, new Set(brackets));
    });
    return matrix;
  }

  function parseBracketCatalog(text) {
    return new Set(String(text || '').split(/\r?\n/).slice(1).map(function (line) {
      return line.trim().toLowerCase();
    }).filter(Boolean));
  }

  function findMismatches(cart, matrix, recognizedBrackets) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var actuatorItems = items.filter(function (item) { return matrix.has(productHandle(item)); });
    var bracketHandles = recognizedBrackets || new Set();
    if (!bracketHandles.size) {
      matrix.forEach(function (brackets) {
        brackets.forEach(function (handle) { bracketHandles.add(handle); });
      });
    }
    var bracketItems = items.filter(function (item) { return bracketHandles.has(productHandle(item)); });
    var mismatches = [];
    if (!actuatorItems.length || !bracketItems.length) return mismatches;

    bracketItems.forEach(function (bracket) {
      var bracketHandle = productHandle(bracket);
      var compatibleActuators = actuatorItems.filter(function (actuator) {
        var actuatorHandle = productHandle(actuator);
        return matrix.get(actuatorHandle).has(bracketHandle);
      });
      if (compatibleActuators.length) return;

      var actuatorHandles = actuatorItems.map(productHandle).sort();
      var onlyActuator = actuatorItems.length === 1 ? actuatorItems[0] : null;
      mismatches.push({
        bracketHandle: bracketHandle,
        bracketTitle: bracket.product_title || bracket.title || bracketHandle,
        actuatorHandle: actuatorHandles.join('+'),
        actuatorTitle: onlyActuator
          ? (onlyActuator.product_title || onlyActuator.title || productHandle(onlyActuator))
          : 'any actuator currently in your cart'
      });
    });
    return mismatches;
  }

  function signature(mismatches) {
    return mismatches.map(function (item) {
      return item.bracketHandle + '>' + item.actuatorHandle;
    }).sort().join('|');
  }

  function addStyles() {
    if (document.getElementById('fg-bracket-compatibility-styles')) return;
    var style = document.createElement('style');
    style.id = 'fg-bracket-compatibility-styles';
    style.textContent =
      '#fg-bracket-compatibility-dialog{max-width:620px;width:calc(100% - 32px);border:0;border-radius:12px;padding:0;box-shadow:0 20px 60px rgba(0,0,0,.3);color:#172b3a}' +
      '#fg-bracket-compatibility-dialog::backdrop{background:rgba(5,25,39,.58)}' +
      '.fg-bracket-warning__body{padding:24px}' +
      '.fg-bracket-warning__title{margin:0 0 12px;font-size:24px;line-height:1.25;color:#b42318}' +
      '.fg-bracket-warning__intro{margin:0 0 12px}' +
      '.fg-bracket-warning__list{margin:0 0 14px;padding-left:22px}' +
      '.fg-bracket-warning__list li{margin:8px 0}' +
      '.fg-bracket-warning__note{margin:0 0 20px;font-size:14px}' +
      '.fg-bracket-warning__actions{display:flex;flex-wrap:wrap;gap:10px;justify-content:flex-end}' +
      '.fg-bracket-warning__actions a,.fg-bracket-warning__actions button{appearance:none;border-radius:6px;padding:11px 18px;font:inherit;font-weight:700;cursor:pointer;text-decoration:none}' +
      '.fg-bracket-warning__review{border:1px solid #087cca;background:#087cca;color:#fff}' +
      '.fg-bracket-warning__close{border:1px solid #a9b6bf;background:#fff;color:#172b3a}' +
      '.fg-bracket-warning--fallback{position:fixed;z-index:2147483000;left:50%;top:50%;transform:translate(-50%,-50%);background:#fff}' +
      '@media(max-width:520px){.fg-bracket-warning__body{padding:20px}.fg-bracket-warning__actions>*{width:100%;text-align:center}}';
    document.head.appendChild(style);
  }

  function showWarning(mismatches) {
    var currentSignature = signature(mismatches);
    if (!currentSignature || getDismissedSignature() === currentSignature) return;
    addStyles();

    var old = document.getElementById('fg-bracket-compatibility-dialog');
    if (old) old.remove();
    var dialog = document.createElement('dialog');
    dialog.id = 'fg-bracket-compatibility-dialog';
    dialog.setAttribute('aria-labelledby', 'fg-bracket-compatibility-title');

    var body = document.createElement('div');
    body.className = 'fg-bracket-warning__body';
    var title = document.createElement('h2');
    title.id = 'fg-bracket-compatibility-title';
    title.className = 'fg-bracket-warning__title';
    title.textContent = configElement.dataset.title;
    var intro = document.createElement('p');
    intro.className = 'fg-bracket-warning__intro';
    intro.textContent = configElement.dataset.intro;
    var list = document.createElement('ul');
    list.className = 'fg-bracket-warning__list';
    mismatches.forEach(function (item) {
      var row = document.createElement('li');
      row.textContent = item.bracketTitle + ' ' + configElement.dataset.doesNotFit + ' ' + item.actuatorTitle + '.';
      list.appendChild(row);
    });
    var note = document.createElement('p');
    note.className = 'fg-bracket-warning__note';
    note.textContent = configElement.dataset.multipleActuators;
    var actions = document.createElement('div');
    actions.className = 'fg-bracket-warning__actions';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'fg-bracket-warning__close';
    close.textContent = configElement.dataset.close;
    close.addEventListener('click', function () {
      setDismissedSignature(currentSignature);
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.remove();
    });
    var review = document.createElement('a');
    review.className = 'fg-bracket-warning__review';
    review.href = configElement.dataset.cartUrl || '/cart';
    review.textContent = configElement.dataset.reviewCart;
    review.addEventListener('click', function () {
      setDismissedSignature(currentSignature);
    });
    actions.appendChild(close);
    actions.appendChild(review);
    body.appendChild(title);
    body.appendChild(intro);
    body.appendChild(list);
    body.appendChild(note);
    body.appendChild(actions);
    dialog.appendChild(body);
    document.body.appendChild(dialog);

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else {
      dialog.setAttribute('open', '');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.classList.add('fg-bracket-warning--fallback');
    }
  }

  function loadMatrix() {
    if (!matrixPromise) {
      matrixPromise = fetch(configElement.dataset.matrixUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Compatibility matrix could not be loaded.');
          return response.text();
        })
        .then(parseMatrix);
    }
    return matrixPromise;
  }

  function loadBracketCatalog() {
    if (!bracketCatalogPromise) {
      bracketCatalogPromise = fetch(configElement.dataset.bracketCatalogUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Bracket catalogue could not be loaded.');
          return response.text();
        })
        .then(parseBracketCatalog);
    }
    return bracketCatalogPromise;
  }

  function checkCart() {
    return Promise.all([
      loadMatrix(),
      loadBracketCatalog(),
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart could not be loaded.');
        return response.json();
      })
    ]).then(function (results) {
      var mismatches = findMismatches(results[2], results[0], results[1]);
      if (mismatches.length) showWarning(mismatches);
      else {
        clearDismissedSignature();
      }
      return mismatches;
    }).catch(function () {
      return [];
    });
  }

  function scheduleCheck() {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(checkCart, 350);
  }

  function init() {
    configElement = document.getElementById('fg-bracket-compatibility-config');
    if (!configElement || !window.fetch || !window.Map || !window.Set) return;
    scheduleCheck();
    window.addEventListener('pageshow', scheduleCheck);
    document.addEventListener('cart:updated', scheduleCheck);
    document.addEventListener('cart:refresh', scheduleCheck);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        window.setTimeout(scheduleCheck, 1200);
      }
    }, true);
    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
        var url = settings && settings.url ? String(settings.url) : '';
        if (/\/cart\/(add|change|update)(?:\.js)?(?:[?#]|$)/.test(url)) scheduleCheck();
      });
    }
  }

  window.FirgelliBracketCompatibility = {
    parseMatrix: parseMatrix,
    parseBracketCatalog: parseBracketCatalog,
    findMismatches: findMismatches,
    getDismissedSignature: getDismissedSignature,
    setDismissedSignature: setDismissedSignature,
    clearDismissedSignature: clearDismissedSignature,
    checkCart: checkCart
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
